/* eslint-disable react/prop-types */

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/dropdown";
import AppUtility from "../../assets/js/AppUtility";
import { uploadFileService } from "../../services/BlobService";
import CustomInput from "../CustomInput";
import CustomTextArea from "../CustomTextArea";
import { Button } from "@nextui-org/button";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevron-down.svg";
import AppConstant from "../../assets/js/AppConstant";

const SubTicketForm = ({
  onSave,
  onCancel,
  initialData,
  isEditing,
  budgetOptions,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    proposal_amount: undefined,
    description: "",
    proposal_document_file_urls: [],
    proposal_images_urls: [],
    budget_name: "",
    budget_name_custom: "",
  });
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);
  const [selectFiles, setSelectFiles] = useState([]);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
      if (initialData.budget_name) {
        if (budgetOptions.includes(initialData.budget_name)) {
          setSelectedBudget(new Set([initialData.budget_name]));
        } else {
          setSelectedBudget(new Set(["อื่นๆ"]));
          setFormData((prev) => ({
            ...prev,
            budget_name_custom: initialData.budget_name,
          }));
        }
      }
      setSelectFiles([
        ...initialData.proposal_document_file_urls,
        ...initialData.proposal_images_urls,
      ]);
    }
  }, [initialData, isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      budget_name:
        selectedBudgetValue === "อื่นๆ"
          ? prev.budget_name_custom
          : selectedBudgetValue,
      proposal_amount:
        name === "proposal_amount" ? Number(value) : prev.proposal_amount,
    }));
  };

  const handleSubmit = async () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      onSave(true, formData);
    }
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.name.trim()) {
      errors.name = "กรุณากรอกชื่อคำขอย่อย";
    }

    if (!data.proposal_amount || data.proposal_amount === 0) {
      errors.proposal_amount = "กรุณาระบุจำนวนเงินก่อน VAT";
    }

    if (!data.description.trim()) {
      errors.description = "กรุณาเลือกลักษณะค่าใช้จ่าย";
    }

    if (!selectedBudgetValue) {
      errors.budget_name = "กรุณาระบุลักษณะค่าใช้จ่าย";
    }

    if (selectedBudgetValue === "อื่นๆ" && !data.budget_name_custom?.trim()) {
      errors.budget_name_custom = "กรุณาระบุลักษณะค่าใช้จ่ายอื่นๆ";
    }

    if (!selectFiles.length) {
      errors.attachment = "กรุณาแนบไฟล์เอกสาร";
    }

    return errors;
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    try {
      const uuid = AppUtility.uuidv4();
      const dateTimeIso = new Date(
        new Date().getTime() + 7 * 60 * 60 * 1000
      ).toISOString();
      const fileExtension = file.name.split(".").pop();
      const fileName = `${dateTimeIso}_PROPOSAL_${uuid}.${fileExtension}`;

      const uploadedUrl = await uploadFileService(file, file.type, fileName);
      setSelectFiles((data) => [...data, new Map([[file, uploadedUrl]])]);
      setFormData((data) => ({
        ...data,
        proposal_images_urls: file.type.includes("image")
          ? [...data.proposal_images_urls, new Map([[file, uploadedUrl]])]
          : data.proposal_images_urls,
        proposal_document_file_urls: !file.type.includes("image")
          ? [
              ...data.proposal_document_file_urls,
              new Map([[file, uploadedUrl]]),
            ]
          : data.proposal_document_file_urls,
      }));
    } catch (e) {
      setSelectFiles((data) => data.filter((f) => f !== file));
    }
  };

  const removeFile = (fileToRemove) => {
    setSelectFiles(
      selectFiles.filter((fileMap) => {
        const [[currentFile]] = fileMap.entries();
        return currentFile !== fileToRemove;
      })
    );

    setFormData((data) => {
      if (fileToRemove.type.includes("image")) {
        return {
          ...data,
          proposal_images_urls: data.proposal_images_urls.filter((fileMap) => {
            const [[currentFile]] = fileMap.entries();
            return currentFile !== fileToRemove;
          }),
        };
      } else {
        return {
          ...data,
          proposal_document_file_urls: data.proposal_document_file_urls.filter(
            (fileMap) => {
              const [[currentFile]] = fileMap.entries();
              return currentFile !== fileToRemove;
            }
          ),
        };
      }
    });
  };

  const [selectedBudget, setSelectedBudget] = React.useState(new Set([]));

  const selectedBudgetValue = React.useMemo(
    () => Array.from(selectedBudget).join(", ").replaceAll("_", " "),
    [selectedBudget]
  );

  return (
    <>
      <div
        className={`bg-white rounded-xl flex flex-col flex-wrap px-8 py-12 h-fit`}
      >
        <div className="flex flex-col gap-y-5">
          {isEditing && (
            <div className="mb-2 text-blue-500 font-medium">
              แก้ไขค่าใช้จ่าย
            </div>
          )}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
            <CustomInput
              label={"ชื่อค่าใช้จ่าย"}
              name="name"
              onChange={handleChange}
              value={formData.name}
              error={errors.name ? true : false}
              errorMessage={errors.name}
            />
            <div
              className={`relative grid grid-cols-1 lg:grid-cols-${
                selectedBudgetValue === "อื่นๆ" ? "3" : "1"
              } gap-6 w-full`}
            >
              <div className="flex flex-col justify-between">
                <p className="text-sm pb-2 font-medium ">ลักษณะค่าใช้จ่าย</p>

                <Dropdown>
                  <DropdownTrigger
                    classNames={{ content: "min-w-[--trigger-width]" }}
                  >
                    <Button
                      variant="bordered"
                      endContent={<ChevronDown width={10} height={10} />}
                      className={`w-full flex justify-between items-center ${
                        (errors.budget_name || errors.budget_name_custom) &&
                        "border-red-400"
                      }`}
                    >
                      {selectedBudgetValue.length
                        ? selectedBudgetValue
                        : "กรุณาเลือก"}
                    </Button>
                  </DropdownTrigger>
                  <DropdownMenu
                    disallowEmptySelection={false}
                    closeOnSelect={false}
                    selectedKeys={selectedBudget}
                    selectionMode="single"
                    variant="flat"
                    onSelectionChange={setSelectedBudget}
                  >
                    {budgetOptions.map((budget) => (
                      <DropdownItem key={budget}>{budget}</DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                <p className="text-red-500 text-sm ">
                  {errors.budget_name ?? errors.budget_name_custom}
                </p>
              </div>
              {selectedBudgetValue === "อื่นๆ" && (
                <div className="col-span-2">
                  <CustomInput
                    label={" "}
                    name="budget_name_custom"
                    onChange={handleChange}
                    value={formData.budget_name_custom}
                    error={errors.budget_name_custom}
                    errorMessage={errors.budget_name_custom}
                    className=""
                  />
                </div>
              )}
            </div>
          </div>
          <CustomInput
            label={"จำนวนเงินก่อน VAT"}
            type="number"
            endContent={<p className="text-black">THB</p>}
            name="proposal_amount"
            onChange={handleChange}
            value={formData.proposal_amount}
            error={errors.proposal_amount ? true : false}
            errorMessage={errors.proposal_amount}
          />
          <CustomTextArea
            label={"รายละเอียด"}
            lableOpacity={100}
            name="description"
            onChange={handleChange}
            value={formData.description}
            error={errors.description ? true : false}
            errorMessage={errors.description}
          />
          <div className="flex flex-col gap-y-1">
            <input
              ref={fileInputRef}
              type="file"
              className="hidden"
              onChange={handleFileChange}
            />
            <Button
              className={`bg-light-gray-300 text-black w-fit px-4 text-md mt-5 ${
                errors.attachment && "border-red-400 border-2"
              }`}
              radius="sm"
              startContent={<div className="text-md text-black">+</div>}
              onPress={() => fileInputRef.current.click()}
              isDisabled={selectFiles.length >= 5}
            >
              เพิ่มไฟล์
            </Button>

            <div className="flex flex-row flex-wrap gap-x-4 pt-2 gap-y-4">
              {selectFiles.map((fileMap, index) => {
                const [[file, fileName]] = fileMap.entries();

                return (
                  <React.Fragment key={index}>
                    <div className="relative">
                      <button
                        onClick={() => removeFile(file)}
                        className="absolute -top-2 -right-2 bg-black text-white rounded-full w-6 h-6 pb-0.5 leading-none text-base z-10"
                      >
                        ×
                      </button>

                      {file.type.includes("image") ? (
                        <img
                          src={`${AppConstant.STOARGE_ACCOUNT}/ticket-files/${fileName}?${AppConstant.STORAGE_TOKEN}`}
                          alt=""
                          className="rounded-md h-32 w-32 object-cover"
                        />
                      ) : (
                        <div className="h-32 w-32 rounded-xl shrink-0 border-light-gray-300 border-3 bg-white flex items-center justify-center px-5 text-center">
                          <p className="line-clamp-4 break-words text-sm">
                            {file.name}
                          </p>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
            <div
              className={`text-sm space-y-2 ${
                errors.attachment
                  ? "text-red-400"
                  : "text-black text-opacity-50"
              } pt-3`}
            >
              <p>{errors.attachment}</p>
              <p>โปรดแนบไฟล์ดังนี้ (ไฟล์ละไม่เกิน 20MB, จำกัด 5 ไฟล์)</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>ใบขออนุมัติจัดกิจกรรม</li>
                <li>ใบเสนอราคาค่าเช่าพื้นที่, จอแถบในชั้นงาน</li>
                <li>ใบเสร็จ (ถ้ามี) กรณี ชำระค่าจองพื้นที่ล่วงหน้าไปบางส่วน</li>
                <li>เอกสารอื่น ๆ เพื่อประกอบการพิจารณา</li>
              </ul>
            </div>
          </div>
          <div className="w-full flex flex-row gap-x-4 justify-end">
            <Button
              className="bg-black text-white w-fit px-4 text-md mt-5"
              radius="sm"
              onPress={handleSubmit}
            >
              {isEditing ? "อัปเดต" : "บันทึก"}
            </Button>
            <Button
              className="bg-light-gray-300 text-black w-fit px-4 text-md mt-5"
              radius="sm"
              onPress={onCancel}
            >
              ยกเลิก
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubTicketForm;
